import { GetUserProfile, GetUsers, ChangePassword, CreateModerator, AdminChangePassword } from '../../api/user'

const state = {
  logged: {},
  users: []
}

const getters = {
  me: (state) => state.logged
  // canAccessAdmin: (state) => {
  //   if (state.logged.role === 'user') {
  //     return false
  //   } else {
  //     if (state.rolesAdmin.indexOf(state.logged.role) > -1) {
  //       return true
  //     }
  //   }
  // }
}

const mutations = {
  saveMe (state, payload) {
    state.logged = payload
  },
  removeMe (state) {
    state.logged = {}
  },
  populateUsers (state, payload) {
    state.users = payload
  }
}

const actions = {
  RetrieveProfile ({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      if (!state.logged.id || (typeof payload.force === 'boolean' && payload.force)) {
        GetUserProfile(document.redecienciaToken)
          .then(
            success => {
              commit('saveMe', success.data)
              resolve(success.data)
            },
            error => {
              reject(error)
            }
          )
      } else {
        resolve()
      }
    })
  },
  doRemoveMe ({ state, commit }) {
    commit('removeMe')
  },
  getUsers: async ({ state, commit }, payload) => {
    try {
      const success = await GetUsers(payload)
      commit('populateUsers', success.data)
      return success.data
    } catch (error) {
      throw error
    }
  },
  changePassword: async ({ state, commit }, payload) => {
    try {
      const success = await ChangePassword(payload)
      return success
    } catch (error) {
      throw error
    }
  },
  createModerator: async ({ state, commit }, payload) => {
    try {
      const { users } = state
      const success = await CreateModerator(payload)
      commit('populateUsers', [success.data, ...users])
      return success.data
    } catch (error) {
      throw error
    }
  },
  adminChangePassword: async ({ state, commit }, { userId, password }) => {
    try {
      const success = await AdminChangePassword(userId, password)
      if (state.users && state.users.items) {
        const updated = state.users.items.map(u => u.id === userId ? { ...u, ...success.data } : u)
        commit('populateUsers', { ...state.users, items: updated })
      }
      return success.data
    } catch (error) {
      throw error
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js